import { NavLink } from "react-router-dom";
import "./tab.css";

export default function Tab() {
  return (
    <div className="inquiry-tab-container">
      <NavLink
        to="/ask"
        end
        className={({ isActive }) =>
          isActive ? "inquiry-tab-link active" : "inquiry-tab-link"
        }
      >
        소통창구
      </NavLink>

      <NavLink
        to="/faq"
        className={({ isActive }) =>
          isActive ? "inquiry-tab-link active" : "inquiry-tab-link"
        }
      >
        FAQ
      </NavLink>
    </div>
  );
}
